var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.24 21.574c-1.166.39-2.333.519-3.5.519v-.13H7.76V5.63h3.629c1.295 0 2.332.259 3.37.518 1.036.26 1.814.778 2.592 1.426a7.49 7.49 0 0 1 1.685 2.593c.39 1.037.648 2.203.648 3.63 0 1.425-.13 2.722-.648 3.759-.518 1.037-1.167 1.944-1.944 2.592-.778.648-1.815 1.167-2.852 1.426zM12.557 2H4V26.11H8.02v3.89h8.295c1.296 0 2.722-.26 4.018-.778 1.426-.518 2.593-1.167 3.76-2.204 1.166-1.037 2.074-2.203 2.722-3.759.778-1.556 1.037-3.371 1.037-5.445 0-2.074-.389-3.76-.907-5.186-.649-1.556-1.426-2.723-2.463-3.76a8.595 8.595 0 0 0-2.292-1.636 10.59 10.59 0 0 0-1.727-2.253 12.957 12.957 0 0 0-3.63-2.202C15.408 2.259 13.981 2 12.556 2z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpi);
export default __webpack_public_path__ + "static/media/DPI.b9d7e312aedc1419b22436e6acebed52.svg";
export { ForwardRef as ReactComponent };